import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ContactUsLanding from "../views/ContactUsLanding";
import { Helmet } from "react-helmet-async";

export default function ContactUs(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ContactUsLanding/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return (
  <>
    <Helmet>
      <title>Contact Us | Group V Limited</title>
      <meta name="description" content="Get in touch with Group V Limited. Contact us for inquiries about our construction projects and services in Tanzania." />
      <meta property="og:title" content="Contact Us | Group V Limited" />
      <meta property="og:description" content="Get in touch with Group V Limited for all your construction inquiries." />
      <meta property="og:url" content="https://groupv.co.tz/#/contact_us" />
    </Helmet>
    {view}
  </>
	);
}